export type ExportTypeType = {
    short: string;
    long: string;
    enabled: boolean;
};

export class ExportTypes {
    static CSV: ExportTypeType = {
        short: 'csv',
        long: 'text/csv',
        enabled: true,
    };
    static XLSX: ExportTypeType = {
        short: 'xlsx',
        long: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        enabled: true,
    };
    static ODS: ExportTypeType = {
        short: 'ods',
        long: 'application/vnd.oasis.opendocument.spreadsheet',
        enabled: true,
    };
    static PDF: ExportTypeType = {
        short: 'pdf',
        long: 'application/pdf',
        enabled: false,
    };

    static getEnabledTypes(): ExportTypeType[] {
        return Object.values(ExportTypes).filter(type => type.enabled);
    }

    static getEnabledTypesString(): string {
        // return '.csv, .xlsx'
        return ExportTypes.getEnabledTypes()
            .map(type => '.' + type.short)
            .join(', ');
    }
}
